module.exports = __webpack_public_path__ + "img/aside-02.png";